// import Header from './Header.js';
// import Sidebar from './Sidebar.js';
import SideBar from "./SideBar.js";

export default class Layout {
  constructor(app) {
    this.app = app;
    // this.header = null;
    this.sidebar = null;
    this.contentContainer = null;
  }

  render(container) {
    container.innerHTML = `
      <div class="layout">
        <header id="header"></header>
        <div class="layout-content">
          <main id="main-content"></main>
        </div>
        <div class="sidebar" id="sidebar"></div>
      </div>
    `;

    this.contentContainer = container.querySelector('#main-content');
    
    // // Рендерим хедер
    // this.header = new Header(this.app);
    // this.header.render(container.querySelector('#header'));
    
    // Рендерим сайдбар
    this.sidebar = new SideBar(this.app);
    this.sidebar.render(container.querySelector('#sidebar'));
  }
}